module.exports = __webpack_public_path__ + "static/media/salisbury-30.82e0a4cc.jpg";